import script from "./TemplateNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TemplateNavigation.vue?vue&type=style&index=0&id=35e1b5ab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e1b5ab"]])

export default __exports__